import { useCallback } from 'react';
import { useLocale } from '@hooks/useLocale';
export function formatPrice({
  amount,
  currencyCode,
  locale,
  options = {},
}: {
  amount: number;
  currencyCode: string;
  locale: string;
  options?: Intl.NumberFormatOptions;
}) {
  try {
    const formatCurrency = new Intl.NumberFormat(locale, {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      currency: currencyCode,
      ...options,
    });

    return formatCurrency.format(amount);
  } catch (err) {
    const formatCurrency = new Intl.NumberFormat(locale, {
      style: 'currency',
      currencyDisplay: 'symbol',
      currency: currencyCode,
    });

    return formatCurrency.format(amount);
  }
}

export const usePrice = (
  options?: Intl.NumberFormatOptions,
  currencyCode = 'CAD'
) => {
  const locale = useLocale();
  return useCallback(
    (amount?: number): string | null => {
      if (typeof amount !== 'number') return null;
      if (!locale) return amount.toString();

      return formatPrice({ amount, currencyCode, locale, options });
    },
    [locale, currencyCode, options]
  );
};
export default usePrice;
